export const statusFilterOptions = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Archived', value: 'ARCHIVED' },
]

export const discountableStatus = [
  {
    label: 'Yes',
    value: false,
  },
  {
    label: 'No',
    value: true,
  },
]


// WEBPACK FOOTER //
// ./src/utils/catalog/catalog.js